import { Dialog, DialogContent, Badge, Typography, DialogContentText, Box, Grid, FormControlLabel, Checkbox, DialogActions, Button, Stack, ToggleButton, ToggleButtonGroup, FormControl, DialogTitle, Card, CardContent, Paper, Accordion, AccordionSummary, AccordionDetails, TableRow, TableCell, Table } from "@mui/material"
import { Setter } from "../../_/utils/ReactUtils"
import { useState } from "react"
import { Column, Row } from "../../_/components/organization"
import { CharacterStats, Stats } from "../Stats"
import { DndContext, DragEndEvent, DragStartEvent, useDraggable, useDroppable } from "@dnd-kit/core"
import { ShopArmor, ShopItem, ShopItemBase, ShopItemTag, ShopShield, ShopUtil, ShopWeapon, item, shopItems } from "../../content/shop"
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { WeaponDnd } from "./shop/WeaponDnd"
import { ArmorDnd } from "./shop/ArmorDnd"
import { ShieldDnd } from "./shop/ShieldDnd"
import { ItemInSlot } from "./slot/itemInSlot"
import { UtilDnd } from "./shop/UtilDnd"


export const HandDialog = ({ open, setOpen, stats, st }: { open: boolean, setOpen: Setter<boolean>, stats: CharacterStats, st: Stats }) => {

    const [slots, setSlots] = useState<EqSlot[]>([])
    const [pickedItem, setPickedItem] = useState<string | null>(null)

    function handleDragEnd(event: DragEndEvent): void {
        const { active, over } = event;

        const parent = over?.id!!
        const itemId = active?.id
        const slotIndex = slots.findIndex(slot => slot.slotId === parent);

        const itm = item(itemId ? itemId as string : undefined)
        const isCorrectOVer = isItemCorrectForSlot(itm, parent as string)
        if (!isCorrectOVer) return

        if (slotIndex !== -1) {
            const updatedSlots = [...slots];
            updatedSlots[slotIndex] = { slotId: parent as string, itemId: pickedItem };
            setSlots(updatedSlots);
            setItems(updatedSlots, st)
        } else {
            // Add the new slot
            const newSlots = [...slots, { slotId: parent as string, itemId: pickedItem }];
            setSlots(newSlots);
            setItems(newSlots, st)

        }
        setPickedItem(null)
    }

    function handleDragStart(event: DragStartEvent) {
        console.log("start: " + event.active.id)
        setPickedItem(event.active.id.toString())
    }

    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
        >
            <Badge color="primary">
                <DialogTitle>Ekwipunek</DialogTitle>
            </Badge>
            <DialogContent>
                <DialogContentText align="center">
                    Wybierz wyposażenie początkowe
                </DialogContentText>
                <DndContext onDragEnd={handleDragEnd} onDragStart={handleDragStart}>
                    <Row style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        gap: '16px',
                    }}>
                        <Equipment stats={stats} st={st} parents={slots} setParents={setSlots} />
                        <Shop />
                    </Row>
                </DndContext>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setOpen(false)} >Zamknij</Button>
            </DialogActions>
        </Dialog>
    )
}

export interface EqSlot {
    slotId: string,
    itemId: string | null
}


const Equipment = ({ stats, st, parents, setParents }: { stats: CharacterStats, st: Stats, parents: EqSlot[], setParents: Setter<EqSlot[]> }) => {

    const getItemIdBySlotId = (slotId: string): string | null => {
        const slot = parents.find(s => s.slotId === slotId);
        return slot ? slot.itemId : null;
    }

    const renderItem = (slotId: string) => {
        const itemId = getItemIdBySlotId(slotId)

        return (
            <ItemInSlot slotId={slotId} itemId={itemId} parents={parents} setParents={setParents} setStats={st} />
        )
    }

    return (
        <Box width={"600px"}>
            <Column>
                <Typography variant={"h6"} alignItems="left"> ręka 1 </Typography>
                <Droppable key={'Hand1Slot'} slot_id={"Hand1Slot"}>
                    {renderItem('Hand1Slot')}
                </Droppable>
                <Typography variant={"h6"} alignItems="left"> ręka 2 </Typography>
                <Droppable key={'Hand2Slot'} slot_id={"Hand2Slot"}>
                    {renderItem('Hand2Slot')}
                </Droppable>
                <Typography variant={"h6"} alignItems="left"> pancerz </Typography>
                <Droppable key={'ArmorSlot'} slot_id={"ArmorSlot"}>
                    {renderItem('ArmorSlot')}
                </Droppable>
                <Typography variant={"h6"} alignItems="left"> pod ręką </Typography>
                <Droppable key={'HandySlot'} slot_id={"HandySlot"}>
                    {renderItem('HandySlot')}
                </Droppable>
            </Column>
        </Box>
    )
}

const Shop = () => {

    const [expanded, setExpanded] = useState<string | false>('weapon');

    const handleChange =
        (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
            setExpanded(newExpanded ? panel : false);
        };

    return (
        <Box width={"600px"}>
            <Column>
                <Accordion expanded={expanded === "weapon"} onChange={handleChange('weapon')}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1-content"
                        id="panel1-header">
                        Bronie
                    </AccordionSummary>
                    <AccordionDetails>
                        <Column>
                            {shopItems.filter(item => item.tags.includes(ShopItemTag.Weapon)).map(weapon => <>
                                <Draggable id={weapon.id}>
                                    <WeaponDnd weapon={weapon as ShopWeapon} />
                                </Draggable>
                            </>)}
                        </Column>
                    </AccordionDetails>
                </Accordion>
                <Accordion expanded={expanded === "armor"} onChange={handleChange('armor')}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2-content"
                        id="panel2-header">
                        Pancerze
                    </AccordionSummary>
                    <AccordionDetails>
                        <Column>
                            {shopItems.filter(item => item.tags.includes(ShopItemTag.Armor)).map(armor => <Draggable id={armor.id}>
                                <ArmorDnd armor={armor as ShopArmor} />
                            </Draggable>)}
                        </Column>
                    </AccordionDetails>
                </Accordion>
                <Accordion expanded={expanded === "shield"} onChange={handleChange('shield')}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel3-content"
                        id="panel3-header">
                        Tarcze
                    </AccordionSummary>
                    <AccordionDetails>
                        <Column>
                            {shopItems.filter(item => item.tags.includes(ShopItemTag.Shield)).map(shield =>
                                <Draggable id={shield.id}>
                                    <ShieldDnd shield={shield as ShopShield} />
                                </Draggable>
                            )}
                        </Column>
                    </AccordionDetails>
                </Accordion>
                <Accordion expanded={expanded === "utils"} onChange={handleChange('utils')}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel4-content"
                        id="panel4-header">
                        Użytkowe
                    </AccordionSummary>
                    <AccordionDetails>
                        <Column>
                            {shopItems.filter(util => util.tags.includes(ShopItemTag.Util)).map(util =>
                                <Draggable id={util.id}>
                                    <UtilDnd util={util as ShopUtil} />
                                </Draggable>
                            )}
                        </Column>
                    </AccordionDetails>
                </Accordion>
            </Column>
        </Box>
    )
}

function Droppable({ children, slot_id }: { children: React.ReactNode, slot_id: string }) {
    const { active, isOver, setNodeRef } = useDroppable({
        id: slot_id,
    });

    const itemId = active?.id ? active?.id as string : undefined
    const itm = item(itemId)
    const isCorrectOVer = isItemCorrectForSlot(itm, slot_id)

    const elevation = (isCorrectOVer && isOver) ? 24 : 4;

    return (
        <Card ref={setNodeRef} elevation={elevation}>
            <Box minHeight={50} display="flex" justifyContent="left" alignItems="center">
                {children}
            </Box>
        </Card>
    );
}

function Draggable({ children, id }: { children: React.ReactNode, id: string }) {
    const { attributes, listeners, setNodeRef, transform } = useDraggable({
        id: id,
    });
    const style = transform ? {
        transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
        padding: 0
    } : {
        padding: 0
    };

    return (
        <button ref={setNodeRef} style={style} {...listeners} {...attributes}>
            {children}
        </button>
    );
}

export const setItems = (slots: EqSlot[], st: Stats) => {
    const hand1ItemId = slots.find(s => s.slotId === "Hand1Slot")?.itemId
    const hand2ItemId = slots.find(s => s.slotId === "Hand2Slot")?.itemId
    const amorItemId = slots.find(s => s.slotId === "ArmorSlot")?.itemId
    const handyItemId = slots.find(s => s.slotId === "HandySlot")?.itemId

    console.log([hand1ItemId, hand2ItemId, amorItemId, handyItemId])
    st.right_hand(hand1ItemId ? hand1ItemId : undefined)
    st.left_hand(hand2ItemId ? hand2ItemId : undefined)
    st.armor_item(amorItemId ? amorItemId : undefined)
    st.handy(handyItemId ? handyItemId : undefined)
}

const isItemCorrectForSlot = (item: ShopItemBase | undefined, slot: string): boolean => {
    if (item == null) return false;

    if (slot === 'Hand1Slot' && (item.tags.includes(ShopItemTag.Weapon) || item.tags.includes(ShopItemTag.Util)))
        return true;

    if (slot === 'Hand2Slot' && item.tags.includes(ShopItemTag.Weapon) || item.tags.includes(ShopItemTag.Shield) || item.tags.includes(ShopItemTag.Util))
        return true;

    if (slot === 'ArmorSlot' && item.tags.includes(ShopItemTag.Armor))
        return true;

    if (slot === 'HandySlot' && (item.tags.includes(ShopItemTag.Weapon) || item.tags.includes(ShopItemTag.Util)))
        return true;

    return false;
}
